import classNames from "classnames";
import ReactDOM from "react-dom";
import ErrorBoundary from "./ErrorBoundary";
import SideNav from "../features/navigation/SideNav";
import UserMenu from "../features/navigation/UserMenu";
// import Button from "./Button";
import styles from "./aside.module.css";

const Aside = ({ expanded, onToggle }) => {
  return ReactDOM.createPortal(
    <>
      <aside
        className={classNames(styles.aside, {
          [styles.expanded]: expanded,
          [styles.collapsed]: !expanded,
        })}
      >
        <ErrorBoundary fallback="Error side nav">
          <SideNav expanded={expanded} />
          {/*
          <div className={styles.buttonGroup}>
            <Button
              onClick={onToggle}
              icon={expanded ? "collapseLeft" : "collapseRight"}
            />
          </div>
          */}
        </ErrorBoundary>
      </aside>
      <div
        style={{
          position: "fixed",
          top: "0",
          right: "0",
          padding: "var(--size-2) var(--size-1)",
        }}
      >
        <UserMenu />
      </div>
    </>,
    document.getElementById("sideNav")
  );
};

export default Aside;
